<template>
  <v-container
    :class="!isMobileView ? 'px-0 pt-2' : 'px-3 pt-2'"
    id="contact_form"
  >
    <v-row
      :style="
        (!$vuetify.breakpoint.mdAndUp && hasObject
          ? 'margin-top:48px !important;'
          : '') + 'background: white;'
      "
    >
      <template v-if="!bookingSent">
        <v-col
          v-if="!sidebar"
          cols="12"
          class="pt-1 pb-0"
        >
          <a id="booking_form"></a>
          <h1>{{ hasObject ? $i18n.t('broneeri_kohe') : $i18n.t('saada') }}</h1>
        </v-col>
        <v-col
          v-if="hasObject && !computedMobile"
          cols="12"
          class="px-0 pt-0 pb-1"
        >
          <ListObject
            v-if="!loadingObjectInfo"
            :object="object"
            :booking-now="true"
            :hide-price="true"
          />
          <div
            v-else
            :style="
              'height: ' +
              ($vuetify.breakpoint.mdAndUp ? 188 : 420) +
              'px;text-align:center;'
            "
          >
            <my-loader :spacing="50" />
          </div>
        </v-col>
        <template v-else-if="hasObject && !sidebar">
          <v-col
            cols="8"
            class="pb-0"
          >
            <h3>{{ object.objectName }}, {{ object.address }}</h3>
          </v-col>
          <v-col
            cols="4"
            class="pb-0"
          >
            <img
              v-if="object && object.objectImages && object.objectImages[0]"
              :src="
                'https://s3.eu-central-1.amazonaws.com/img.costasolrent.com/objectImages/preview/' +
                object.objectImages[0].image
              "
              class="costa-border"
              width="100%"
            />
          </v-col>
          <v-col
            cols="9"
            class="pt-1"
          >
          </v-col>
          <v-col
            cols="3"
            class="pt-1"
            style="text-align: center"
          >
            ID: {{ object.csrId }}
          </v-col>
        </template>
        <v-col
          cols="12"
          style="width: 100%"
        >
          <v-container class="pa-0">
            <v-row dense>
              <!-- CUSTOMER NAME -->

              <v-col
                v-if="!sidebar"
                :cols="computedMobile ? 12 : 6"
              >
                <v-text-field
                  v-model="bookingData.customerName"
                  :label="$i18n.t('nimi') + ' *'"
                  :error="showRequiredError && !bookingData.customerName"
                  outlined
                  hide-details
                />
              </v-col>

              <!-- E-MAIL -->

              <v-col
                v-if="!sidebar"
                :cols="computedMobile ? 12 : 6"
              >
                <v-text-field
                  v-model="bookingData.customerEmail"
                  :label="$i18n.t('e-mail') + ' *'"
                  :error="
                    showRequiredError &&
                    !isValidEmail(bookingData.customerEmail)
                  "
                  outlined
                  hide-details
                />
              </v-col>

              <!-- PHONE EXT -->

              <v-col
                v-if="!sidebar"
                :cols="computedMobile ? 4 : 2"
              >
                <v-select
                  v-model="selectedCountryCallingCode"
                  :items="countryCallingCodeOptions"
                  label=""
                  ref="phoneField"
                  autocomplete="off"
                  outlined
                  hide-details
                  :menu-props="{
                    contentClass: 'phone-select',
                  }"
                  @focus_="focusPhoneField"
                  @click_="autoBlurPhone"
                >
                  <template
                    v-slot:item="{ item, index }"
                    style="height: 20px"
                  >
                    {{ item.textLong }}
                  </template>
                </v-select>
              </v-col>

              <!-- PHONE -->

              <v-col
                v-if="!sidebar"
                :cols="computedMobile ? 8 : 4"
              >
                <v-text-field
                  v-model="bookingData.customerPhone"
                  :label="$i18n.t('telefon') + ' *'"
                  :error="showRequiredError && !bookingData.customerPhone"
                  outlined
                  hide-details
                />
              </v-col>

              <!-- VISITORS -->

              <v-col :cols="computedMobile ? 12 : 6">
                <BookingFormVisitorSelect
                  :sidebar="sidebar"
                  @addPerson="addPerson"
                  @removePerson="removePerson"
                  @close="personSelectOpened = false"
                />
              </v-col>

              <v-col
                :cols="sidebar ? 12 : computedMobile ? 6 : 3"
                class="search-form-date-input"
              >
                <div style="float: left; width: 100%">
                  <!-- START DATE -->

                  <v-text-field
                    v-model="searchFilters.dateStart"
                    :label="$t('saabumise_kuupäev')"
                    :dense="sidebar"
                    type="text"
                    autocomplete="off"
                    name="arrival"
                    id="arrival"
                    class="date-search-field"
                    prepend-inner-icon="fa-calendar-alt"
                    hide-details
                    outlined
                    readonly
                    @focus="dateStartFocus($event)"
                  />
                  <calendar-date-picker
                    v-if="showBookingPickerFor === 'dateStart'"
                    v-model="searchFilters.dateStart"
                    fieldName="dateStart"
                    :left="calendarLeftPosition"
                    :mobile-padding="calendarMobilePadding"
                    @update="updatePickerDate"
                  />
                </div>
              </v-col>
              <v-col
                v-if="!sidebar"
                :cols="computedMobile ? 6 : 3"
              >
                <!-- CHECK IN TIME -->

                <v-select
                  v-model="bookingData.checkInTime"
                  :items="checkInTimes"
                  :label="$t('check_in_time')"
                  class="check-in-time"
                  prepend-inner-icon="fa-clock"
                  outlined
                  hide-details
                />
              </v-col>

              <v-col
                :cols="sidebar ? 12 : computedMobile ? 6 : 3"
                class="search-form-date-input"
              >
                <div style="float: left; width: 100%">
                  <!-- END DATE -->

                  <v-text-field
                    v-model="searchFilters.dateEnd"
                    :label="$t('lahkumise_kuupäev')"
                    :dense="sidebar"
                    autocomplete="off"
                    id="leaving"
                    class="date-search-field"
                    prepend-inner-icon="fa-calendar-alt"
                    hide-details
                    outlined
                    readonly
                    @focus="dateEndFocus($event)"
                  />
                  <calendar-date-picker
                    v-if="showBookingPickerFor === 'dateEnd'"
                    v-model="searchFilters.dateEnd"
                    :starting-from="searchFilters.dateStart"
                    fieldName="dateEnd"
                    :mobile-padding="calendarMobilePadding"
                    :left="calendarLeftPosition"
                    @update="updatePickerDate"
                  />
                </div>
              </v-col>
              <v-col
                v-if="!sidebar"
                :cols="computedMobile ? 6 : 3"
              >
                <!-- CHECK OUT TIME -->

                <v-select
                  v-model="bookingData.checkOutTime"
                  :items="checkOutTimes"
                  :label="$t('check_out_time')"
                  class="check-out-time"
                  prepend-inner-icon="fa-clock"
                  outlined
                  hide-details
                />
              </v-col>

              <v-col
                v-if="!sidebar && hasObject"
                :cols="12"
                style="width: 100%; position: relative; overflow: hidden"
              >
                <div
                  style="
                    width: 100%;
                    overflow: auto;
                    position: absolute;
                    height: 60px;
                    z-index: 1;
                    opacity: 0;
                    cursor: text;
                  "
                  @click.stop="extrasSelectOpened = !extrasSelectOpened"
                />
                <v-text-field
                  :label="$i18n.t('booking_extras') + ' *'"
                  :placeholder="selectedExtrasText"
                  :persistent-placeholder="!!selectedExtrasText"
                  :dense="sidebar"
                  outlined
                  hide-details
                />
              </v-col>

              <BookingFormExtras
                v-if="!sidebar && hasObject && extrasSelectOpened"
                :object="object"
                :sidebar="sidebar"
                @close="extrasSelectOpened = false"
              />

              <v-col
                v-if="!sidebar"
                cols="12"
              >
                <v-textarea
                  v-model="bookingData.notes"
                  :label="$i18n.t('sõnum')"
                  :rows="3"
                  outlined
                  hide-details
                />
              </v-col>

              <v-col
                v-if="hasObject && !this.computedMobile && rentalPrice"
                :cols="computedMobile ? 12 : 3"
              >
                <label>{{ $i18n.t('total_price') }}</label>
              </v-col>

              <!-- TOTAL PRICE -->
              <BookingPriceTable
                v-if="
                  hasObject &&
                  searchFilters.dateStart &&
                  searchFilters.dateEnd &&
                  rentalPrice &&
                  !loadingObjectInfo
                "
                :has-object="hasObject"
                :object="object"
                :sidebar="sidebar"
              />

              <v-col
                v-else-if="hasObject && loadingObjectInfo"
                cols="12"
                class="text-center"
              >
                <v-progress-circular
                  indeterminate
                  color="amber"
                  size="25"
                  width="2"
                />
              </v-col>
              <v-col
                v-else-if="
                  hasObject &&
                  (!searchFilters.dateStart || !searchFilters.dateEnd)
                "
                cols="12"
                style="color: red"
              >
                {{ $i18n.t('please_select_dates') }} *
              </v-col>
              <v-col
                v-else-if="hasObject"
                cols="12"
              >
                <span style="color: red">
                  {{ $i18n.t('dates_not_available') }}
                </span>
              </v-col>

              <!-- TERMS CONFIRM -->

              <!-- v-col
                v-if="hasObject && !sidebar"
                cols="12"
              >
                <label>&nbsp;</label>
              </v-col -->

              <v-col
                v-if="hasObject && !sidebar"
                cols="12"
              >
                <input
                  v-model="bookingData.confirmed"
                  type="checkbox"
                  style="color: rgb(128, 128, 128)"
                />
                &nbsp;<a
                  target="_blank"
                  :href="conditionsLink"
                  >{{ $i18n.t('terms_and_conditions_link') }}</a
                >
              </v-col>

              <!-- SEND BUTTON -->

              <v-col
                v-if="!sidebar"
                cols="12"
              >
              </v-col>
              <v-col
                cols="12"
                @mouseenter="showRequiredError = true"
              >
                <v-btn
                  :disabled="!canBookNow"
                  class="csr-large-text-btn"
                  block
                  @click="clickHandler"
                >
                  {{ hasObject ? $i18n.t('book_button') : $i18n.t('saada') }}
                </v-btn>
              </v-col>

              <!-- NO CHARGES TEXT -->

              <v-col
                v-if="hasObject && !computedMobile"
                class="pa-1"
              >
              </v-col>
              <v-col
                v-if="hasObject"
                cols="12"
                class="text-center pt-2 pb-1"
                style="color: #4caf50; /* #219bc8 */"
              >
                <b>{{ $i18n.t('no_charges_yet') }}</b>
              </v-col>
              <v-col
                v-if="hasObject && sidebar"
                cols="12"
                class="pa-1"
              >
                <i v-if="showValidationError">
                  {{ $i18n.t('fill_all_fields') }}
                </i>
              </v-col>

              <!-- BACK BUTTON -->

              <v-col
                v-if="hasObject && !sidebar && !isMobileView"
                xs-12
                mt-3
                class="text-right"
              >
                <v-btn
                  @click="goBack"
                  dense
                  small
                >
                  &lt; {{ $t('tagasi') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </template>
      <template v-else>
        <v-col cols="12">
          <h1>{{ $t('booking_sent_title') }}</h1>
          <div v-html="$t('booking_sent_message')" />
        </v-col>
      </template>
    </v-row>
  </v-container>
</template>

<script>
import MyLoader from '../App/_MyLoader'
import BookingFormExtras from './BookingFormExtras'
import moment from 'moment'
import sharedMethods from '../../methods/sharedMethods'
import CalendarDatePicker from '../Calendar/CalendarDatePicker'
import { createHelpers } from 'vuex-map-fields'
import state from '../../store/state.js'
import sharedObjectComputed from '@/methods/sharedObjectComputed'
import ListObject from '@/components/List/ListObject/ListObject'
import BookingFormVisitorSelect from '@/components/Forms/BookingFormVisitorSelect'
import BookingPriceTable from '@/components/Forms/BookingPriceTable'
import sharedComputed from '@/methods/sharedComputed'
const countryCodes = require('country-codes-list')

const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField',
})

const countryCallingCodesByLocale = {
  et: '+372',
  fi: '+358',
  ru: '+7',
  es: '+34',
  en: '+44',
}

export default {
  name: 'BookingForm',

  components: {
    BookingPriceTable,
    BookingFormVisitorSelect,
    ListObject,
    CalendarDatePicker,
    BookingFormExtras,
    MyLoader,
  },

  data: () => {
    return {
      showRequiredError: false,
      personSelectOpened: false,
      extrasSelectOpened: false,
      showValidationError: false,
      bookingSent: false,
      cleaningFee: 65,
      x: 0,
      y: 0,
      selectedCountryCallingCode: null,
    }
  },

  props: {
    object: {
      type: Object,
      default: () => {
        return {}
      },
    },
    sidebar: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    bookObjectId() {
      this.limitMaxPeople()
      this.resetExtras()
    },
  },

  computed: {
    ...mapFields(Object.keys(state)),
    ...sharedComputed,
    ...sharedObjectComputed,

    countryCallingCodeOptions() {
      return Object.keys(this.countryCallingCodes).map((key) => {
        return {
          text: '+' + key,
          value: '+' + key,
          textLong: this.countryCallingCodes[key],
        }
      })
    },

    countryCallingCodes() {
      return countryCodes.customList(
        'countryCallingCode',
        '{countryNameLocal} (+{countryCallingCode})'
      ) // countryNameEn
    },

    hasObject() {
      return !!(this.object && this.object.id)
    },

    calendarLeftPosition() {
      return this.sidebar ? '-20px' : '0px'
    },

    calendarMobilePadding() {
      return 13
    },

    selectedExtrasText() {
      const selectedText = this.bookingExtras
        .map((bookingExtra, index) => {
          if (this.bookingExtrasSelected[index]) {
            const count = this.bookingExtrasSelected[index]
            if (count > 0) {
              const nameField =
                count > 1 ? 'namePlural_' + this.lang : 'name_' + this.lang
              return (
                this.bookingExtrasSelected[index] +
                ' ' +
                (bookingExtra[nameField] &&
                  bookingExtra[nameField].toLowerCase())
              )
            }
            return null
          }
          return 0
        })
        .filter((name) => name)
        .join(', ')

      return selectedText || this.$i18n.t('select')
    },

    conditionsLink() {
      return (
        this.pagesById &&
        this.pagesById['5e00d1adbd2fe35f079f24b5']['seoName_' + this.lang] +
          '_' +
          this.lang +
          '_page.html?showArticleOnly=1'
      )
    },

    bookObjectId() {
      return (this.object && this.object._id) || null
    },

    computedMobile() {
      return this.mobile || this.sidebar || !this.$vuetify.breakpoint.mdAndUp
    },

    /*loadingObjectInfo () {

      return !this.object || (this.object && !this.object._id)
    },*/

    bookingEndLeftForMobile() {
      let left =
        window.innerWidth < 400 ? -1 * (window.innerWidth / 2 - 60) + 'px' : ''
      return left
    },

    confirmed() {
      return this.bookingData.confirmed
    },

    canBookNow() {
      const objectAvailable =
        this.searchFilters.dateStart &&
        this.searchFilters.dateEnd &&
        this.bookNowAvailable &&
        this.bookingData.confirmed
      return (
        this.sidebar ||
        ((objectAvailable || !this.hasObject) &&
          this.bookingData.customerName &&
          this.bookingData.customerEmail &&
          this.isValidEmail(this.bookingData.customerEmail) &&
          this.bookingData.customerPhone &&
          this.bookingData.adults > 0)
      )
    },

    checkInTimes() {
      let momentFriendly = ''
      let nextDay = ''
      const options = []
      if (this.searchFilters.dateStart) {
        const p = this.searchFilters.dateStart.split('.')
        momentFriendly = p[2] + '-' + p[1] + '-' + p[0]
        nextDay = moment(momentFriendly).add(1, 'day').format('DD.MM')
      }
      ;[...Array(14)].forEach((c, i) => {
        let isNextDay = false
        let s = i + 16
        if (s >= 24) {
          s = s - 24
          isNextDay = true
        }
        const h = s < 10 ? '0' + s : s
        options.push(h + ':00' + (isNextDay && nextDay ? ' / ' + nextDay : ''))
      })
      return options.map((option) => {
        return {
          text: option,
          value: option,
        }
      })
    },

    checkOutTimes() {
      return [...Array(13)]
        .map((c, i) => {
          const h = i < 10 ? '0' + i : i
          return h + ':00'
        })
        .map((option) => {
          return {
            text: option,
            value: option,
          }
        })
    },
  },

  created() {
    this.selectedCountryCallingCode = countryCallingCodesByLocale[this.lang]
    this.bookingData.confirmed = false
    this.bookingSent = false

    this.limitMaxPeople()
    // this.resetExtras()
  },

  methods: {
    ...sharedMethods,

    isValidEmail(email) {
      if (!email) {
        return false
      }
      return String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
    },

    autoBlurPhone() {
      // Deny input (mobile keyboard)
      // this.$refs.phoneField.blur()
      // console.log(22, this.$refs.phoneField)
    },

    focusPhoneField(e) {
      this.$nextTick(() => {
        // Clear selection, no other good way
        if (window.getSelection) {
          if (window.getSelection().empty) {
            window.getSelection().empty()
          } else if (window.getSelection().removeAllRanges) {
            window.getSelection().removeAllRanges()
          }
        }
      })
    },

    dateStartFocus(e) {
      e.srcElement.blur()
      this.showBookingPickerFor = 'dateStart'

      // scroll to on mobile
      if (!this.isMobileView) {
        return
      }
      this.$vuetify.goTo('#arrival', {
        duration: 300,
        easing: 'easeInOutCubic',
        offset: 250,
      })
    },

    dateEndFocus(e) {
      e.srcElement.blur()
      this.showBookingPickerFor = 'dateEnd'

      // scroll to on mobile
      if (!this.isMobileView) {
        return
      }
      this.$vuetify.goTo('#leaving', {
        duration: 300,
        easing: 'easeInOutCubic',
        offset: 250,
      })
    },

    limitMaxPeople() {
      this.$store.dispatch('limitMaxPeople')
    },

    resetExtras() {
      this.bookingExtrasSelected = {}
    },

    goBack() {
      window.history.back()
    },

    clickHandler() {
      if (!this.canBookNow) {
        return
      }
      if (this.sidebar) {
        // this.showBookNowForm = true
        this.$router.push({ path: this.objectBookingLink(this.object) })
      } else {
        this.sendBooking()
        window.scrollTo(0, 0)
      }
    },

    // handleShowDayPricesClick (e) {
    //   e.preventDefault()
    //     this.showDayPrices = false
    //     this.x = e.clientX
    //     this.y = e.clientY
    //     this.$nextTick(() => {
    //       this.showDayPrices = true
    //     })
    // },

    sendBooking() {
      this.bookingData.customerPhone =
        this.selectedCountryCallingCode + ' ' + this.bookingData.customerPhone
      if (!this.hasObject) {
        this.bookingSent = true
        this.$store
          .dispatch('sendContact', {
            contact: this.bookingData,
            translations: {
              name: this.$i18n.t('nimi'),
              email: this.$i18n.t('e-mail'),
              phone: this.$i18n.t('telefon'),
              guests: this.$i18n.t('inimeste_arv'),
              checkinDate: this.$i18n.t('saabumise_kuupäev'),
              checkoutDate: this.$i18n.t('lahkumise_kuupäev'),
              adults: this.$i18n.t('adults_count'),
              kids: this.$i18n.t('kids_count'),
              infants: this.$i18n.t('infants_count'),
              message: this.$i18n.t('sõnum'),
            },
          })
          .then()
        return
      }
      this.showValidationError = false
      if (!this.canBookNow) {
        this.showValidationError = true
        return
      }
      this.bookingSent = true
      this.$store
        .dispatch('sendBooking', {
          booking: {
            ...this.bookingData,
            lateCheckInFee: this.lateCheckInFee,
            object: this.priceObject._id,
            priceCalculatedConfirmation: this.priceObject.bookingPrice,
            objectInfo: this.priceObject,
          },
          translations: {
            name: this.$i18n.t('nimi'),
            email: this.$i18n.t('e-mail'),
            phone: this.$i18n.t('telefon'),
            guests: this.$i18n.t('inimeste_arv'),
            checkinDate: this.$i18n.t('saabumise_kuupäev'),
            checkoutDate: this.$i18n.t('lahkumise_kuupäev'),
            adults: this.$i18n.t('adults_count'),
            kids: this.$i18n.t('kids_count'),
            infants: this.$i18n.t('infants_count'),
            message: this.$i18n.t('sõnum'),
            csr_fee: this.$i18n.t('csr_fee'),
            cleaning: this.$i18n.t('cleaning'),
            rental_price: this.$i18n.t('rental_price'),
            late_checkin_fee: this.$i18n.t('late_checkin_fee'),
            reservation_fee: this.$i18n.t('reservation_fee'),
            booking_extras: this.$i18n.t('booking_extras'),
            total_price: this.$i18n.t('total_price'),
            monthly_price: this.$i18n.t('monthly_price'),
            month: this.$i18n.t('month'),
            internet_month_price: this.$i18n.t('internet_month_price'),
            water_month_price: this.$i18n.t('water_month_price'),
            water: this.$i18n.t('water'),
            internet: this.$i18n.t('internet'),
            booking: this.$i18n.t('broneering'),
            night: this.$i18n.t('öö'),
            nights: this.$i18n.t('ööd'),
          },
        })
        .then(() => {})
    },
  },
}
</script>

<style lang="scss">
#contact_form,
.calendar-container {
  .v-text-field {
    .v-input__slot {
      /*min-height: 36px !important;*/
      background: white !important;
      /* height: 36px; */
      .v-input__icon--prepend-inner {
        i {
          font-size: 18px;
        }
      }
    }
  }
}
.full-input {
  width: 100%;
}
textarea.contact_input {
  /*
    height: 150px;
    color: rgb(128, 128, 128);
    */
}
ul.contact_form li {
  list-style-type: none;
  margin-bottom: 5px;
}

.costa-close .v-btn--floating.v-btn--small {
  width: 24px;
  height: 24px;
}
.popup-select-container {
  margin: 0 0 10px 0;
  padding: 20px;
}
.popup-select-container-sidebar {
  margin: 10px 0 10px 0;
  padding: 13px;
}
@media screen and (max-width: 700px) {
  .popup-select-container {
    padding: 13px;
  }
}
.sidebar-plus {
  margin: 5px -5px 5px 5px !important;
}
.sidebar-minus {
  margin: 5px 7px 5px -7px !important;
}
.check-in-time,
.check-out-time {
  .v-select__selection {
    color: #4caf50 !important;
  }
}
.phone-select {
  border-radius: 10px !important;
  border: 1px solid #eee;
  font-size: 16px;
  .v-list-item:not(:first-child) {
    border-top: 1px solid #eee;
  }
}
</style>
